import { createStore } from '@souche-f2e/muji';
import { debugApi } from '@/services/debug';

const state = {
  debugParams: {
    appKey: '',
    appSecret: '',
    host: '',
    api: '',
    data: '',
  },
  debugResult: {},
  reqBody: {}
};


export default createStore({
  state,
  effects: {
    saveParams(payload){
      this.SET_DEBUG_PARAMS(payload);
    },
    async api(payload) {
      try {
        // this.SET_DEBUG_PARAMS(payload);

        const debugInfo = await debugApi(payload).promise;
        if(debugInfo.data && debugInfo.data.error) {
          this.SET_DEBUG_RESULT(debugInfo.data.error);
          return;
        }
        this.SET_DEBUG_RESULT(debugInfo.data.response.data);
        this.SET_REQ_BODY(debugInfo.data.signBody);
      } catch (error) {
        this.SET_DEBUG_RESULT({
          payload: { error },
        });
      }
    },
  },
  reducers: {
    SET_DEBUG_RESULT(state, payload) {
      return {
        ...state,
        debugResult: payload,
      };
    },
    SET_DEBUG_PARAMS(state, payload) {
      return {
        ...state,
        debugParams: payload,
      };
    },
    SET_REQ_BODY(state, payload) {
      return {
        ...state,
        reqBody: payload,
      };
    },
  },
});
